import React, {FunctionComponent} from "react";
import styles from "./DataTypeSelector.module.css";
import {DataType} from "../selector-bar/SelectorBar";
import background from "../../assets/select-arrow.svg";

const DataTypeSelector: FunctionComponent<{ callbackFn: Function, dataType: DataType }> = ({callbackFn, dataType}) => (
  <>
    <div className={styles.desktop}>
      <button
        className={`${styles.button} ${styles.dataTypeSelector}`}
        onClick={() => callbackFn("region")}
        disabled={dataType === "region"}
      >Region
      </button>
      <button
        className={`${styles.button} ${styles.dataTypeSelector}`}
        onClick={() => callbackFn("sector")}
        disabled={dataType === "sector"}
      >Sector
      </button>
      <button
        className={`${styles.button} ${styles.dataTypeSelector}`}
        onClick={() => callbackFn("revenue")}
        disabled={dataType === "revenue"}
      >Revenue
      </button>
    </div>

    <div className={styles.mobile}>
      <div className={styles.selectorContainer}>
        <select
          className={styles.select}
          onChange={(e) => callbackFn(e.target.value)}
        >
          <option value={"region"}>Region</option>
          <option value={"sector"}>Sector</option>
          <option value={"revenue"}>Revenue</option>
        </select>
        <img
          className={styles.selectArrow}
          src={background}
          alt="select-arrow-down"
          aria-hidden
        ></img>
      </div>
    </div>
  </>
);

export default DataTypeSelector;
